module.exports = __webpack_public_path__ + "static/rap-44322614e9e29e9934ea9ba558dd9413.mp3";